/**
 * Barrel exports for the input system.
 *
 * Prefer importing from this file instead of individual modules, e.g.:
 * - `import { Input } from '@/components/input';`
 * - `import { InputValidator } from '@/components/input';`
 */

// High-level input component API.
export { Input } from './Input';
export type { InputProps, InputTypeFormatter } from './Input';

// Lower-level building blocks, exposed for advanced/custom use cases.
export { BaseInput } from './BaseInput';
export type { BaseInputProps } from './BaseInput';

export { FieldWrapper } from './FieldWrapper';
export type { FieldWrapperProps } from './FieldWrapper';

// Built-in validators that work with the input components.
export * from './validators';
